import { connect } from "react-redux";
import { compose, lifecycle, withState } from 'recompose';
import * as R from 'ramda';

import AdminManagementCommentsComponent from './AdminManagementCommentsComponent';

import { fetchUnverifiedCommentsList, fetchUnverifiedRatingsList } from '../../../../modules/review/reviewAction';

import { REVIEW_TYPE } from './AdminManagementCommentsComponent'

const ITEMS_PER_VIEW = 5;

const AdminManagementCommentsContainer = compose(
  connect( ({ review }) => ({
    comments: review.unverifiedComments,
    unhandledAnswersCount: review.unhandledAnswersCount,
    unhandledCommentsCount: review.unhandledCommentsCount,
    unhandledRatingsCount: review.unhandledRatingsCount,
    totalCommentsCount: review.totalCommentsCount,
    totalRatingsCount: review.totalRatingsCount,
    ratings: review.unverifiedRatings,
    hasMoreComments: review.totalCommentsCount > review.unverifiedComments.length,
    hasMoreRatings: review.totalRatingsCount > review.unverifiedRatings.length
  }), {
    fetchUnverifiedCommentsList,
    fetchUnverifiedRatingsList
  }),
  withState('page', 'setPage', 1),
  withState('commentsStateType', 'setCommentsStateType', REVIEW_TYPE.ALL),
  lifecycle({
    componentDidMount() {
      const { fetchUnverifiedCommentsList, page } = this.props;

      fetchUnverifiedCommentsList({ page, commentsPerView: ITEMS_PER_VIEW });
    },
    componentDidUpdate(prevProps) {
      const { fetchUnverifiedRatingsList, fetchUnverifiedCommentsList, page, setPage, commentsStateType } = this.props;

      const isPropNotEqual = i => !R.equals(R.prop(i, this.props), R.prop(i, prevProps));

      if (commentsStateType !== prevProps.commentsStateType) {
        setPage(1);
      }

      if(['page', 'commentsStateType'].find(isPropNotEqual)) {
        if (commentsStateType === REVIEW_TYPE.RATING) {
          fetchUnverifiedRatingsList({
            page,
            ratingPerView: ITEMS_PER_VIEW,
            skip: commentsStateType !== prevProps.commentsStateType ? 0 : null
          })
        } else {
          fetchUnverifiedCommentsList({
            page,
            commentsPerView: ITEMS_PER_VIEW,
            type: commentsStateType === REVIEW_TYPE.ALL ? null : commentsStateType,
            skip: commentsStateType !== prevProps.commentsStateType ? 0 : null
          });
        }
      }
    }
  })
);

export default AdminManagementCommentsContainer(AdminManagementCommentsComponent);
